import React from "react";
import {
  StyledFormElementsWrapper,
  ContainerGrid,
  FormLabel,
  Subheading,
} from "../styles";
import FormField from "../../../common/FormField/FormField";
import { CustomFileUpload } from "../../../common/FormInputs";
import CustomSelect from "./CustomSelect";
import {
  Grid,
  Radio,
  RadioGroup,
  makeStyles,
  FormControlLabel,
} from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import * as XLSX from "xlsx";

const useStyles = makeStyles(() => ({
  formLabel: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#293461",
  },
}));

const GenerateNotice = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  s3Upload,
  getFileName,
  menuItems,
  menuNotice,
  menuTemplateCode,
  menuHeaderFooter,
  getNoticeTemplates,
  cmId,
  radioInputs,
  radioTypeInputs,
  case_id_inputs,
  noticeDesignTemplate,
  selectedPartyName,
  onPartySelect,
  openTemplatePreview,
  letterHeadArr,
  setModal,
}) => {
  const classes = useStyles();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  const selectedTemplate = menuTemplateCode[values?.noticeCategory]?.find(
    (template) => template?.templateCode === values?.templateCode,
  );

  const handleCategoryChange = (event) => {
    setFieldValue("noticeCategory", event.target.value);
    setFieldValue("templateCode", "");
  };

  const handleTemplateChange = (event) => {
    const template = menuTemplateCode[values?.noticeCategory]?.find(
      (item) => String(item?.id) === String(event.target.value),
    );
    setFieldValue("templateCode", template?.templateCode || "");
    openTemplatePreview(template);
  };

  async function s3UploadContractNumbers(
    file,
    filedName,
    setFieldValue,
    fileName,
  ) {
    if (file) {
      try {
        setLoader({ state: true, message: `Uploading file ${file.name}` });
        const response = await readExcelFile(file, fileName, setFieldValue);
        setFieldValue(filedName, response);
        if (response?.length) {
          setFieldValue(fileName, file.name);
        }
      } catch (err) {
        enqueueSnackbar(err?.message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  /**
   * @description Read xlsx file
   * @param {*} file
   * @returns
   */

  const readExcelFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    const headerRow = data[0];
    const possibleHeaders = [
      "CONTRACT NUMBER",
      "Contract No",
      "Contract Number",
      "contract no",
      "CONTRACT NO",
      "Contract No.",
    ];
    const contractNumberIndex = headerRow.findIndex((header) =>
      possibleHeaders.includes(header.trim()),
    );

    if (contractNumberIndex === -1) {
      enqueueSnackbar("Contract number column not found", {
        variant: "error",
      });
    }

    const contractNumbers = data
      .slice(1)
      .map((row) => row[contractNumberIndex])
      .filter(Boolean);

    return contractNumbers;
  };

  const lot_number_inputs = [
    // {
    //   type: "text",
    //   name: "lotNumber",
    //   label: "Lot Number",
    //   required: true,
    // },
    {
      type: "text",
      name: "exceptCaseIds",
      label: "Except Case IDs (comma separated)",
      required: false,
      placeholder: "e.g., 102, 109, 120",
      helperText: "Optional: exclude specific cases from this lot",
    },
  ];

  const excelTemplate = selectedTemplate?.excelTemplate;

   const selectedLetterHead =
    values?.letterHeadName &&
    letterHeadArr?.[values.letterHeadName]?.[0];
      const selectedNoticeTemplate = menuTemplateCode[
        values?.noticeCategory
      ]?.find(
        (template) => template?.templateCode === values?.templateCode,
      )?.noticeTemplate;

  const inputs = [
    {
      type: "select",
      name: "noticeCategory",
      label: "Notice Category",
      required: true,
      items: menuNotice,
      onChange: handleCategoryChange,
    },
    {
      type: "select",
      name: "templateCode",
      label: "Template Code",
      required: true,
      value: selectedTemplate?.id || "",
      onChange: handleTemplateChange,
      previewUrl: selectedTemplate?.noticeTemplate,
      onPreview: () => openTemplatePreview(selectedTemplate),
      items: menuTemplateCode[values?.noticeCategory]?.length
        ? menuTemplateCode[values?.noticeCategory]?.map(
            ({ id, templateCode, historyDisplay }) => ({
              id,
              label: templateCode,
              value: id,
              historyDisplay,
            }),
          )
        : [],
    },
    {
      type: "select",
      name: "noticeCopyDesign",
      label: "Notice Copy Design",
      required: true,
    //   items: menuItems?.filter((party) => party?.value === values?.partyId)
    //     ?.length
    //     ? menuItems
    //         ?.filter((party) => party?.value === values?.partyId)
    //         .map((item) => [
    //           { label: "Default design", value: "default" },
    //           { label: item.label, value: item.label },
    //         ])[0]
    //     : [{ label: "Default design", value: "default" }],
    // },
     items: selectedPartyName && Object.keys(noticeDesignTemplate || {}).length
        ? [
            { label: "Default design", value: "default" },
            { label: selectedPartyName, value: selectedPartyName },
          ]
        : [{ label: "Default design", value: "default" }],
    },

    { type: "number", name: "lotNo", label: "Lot Number", required: true },
    { type: "text", name: "codeType", label: "Code Type", required: false },
    {
      type: "text",
      name: "arbitratorName",
      label: "Arbitrator Name",
      required: false,
    },
    {
      type: "text",
      name: "institutionName",
      label: "Institution Name",
      required: false,
    },
    {
      type: "select",
      name: "loanType",
      label: "Loan Type",
      required: false,
      items: [
        { label: "Vehicle Loan", value: "vehicleLoan" },
        { label: "Business Loan", value: "businessLoan" },
        { label: "Personal Loan", value: "personalLoan" },
      ],
    },
    {
      type: "select",
      name: "loanStatus",
      label: "Loan Status",
      required: false,
      items: [
        { label: "Matured", value: "matured" },
        { label: "Short Fall", value: "shortFall" },
        { label: "Running", value: "running" },
      ],
    },
  ];

  const upload_templates = [
    {
      name: "excelFile",
      label: "Upload Excel Template (xlsx)",
      type: "upload",
      required: true,
      accept: ".xlsx",
      types: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ],
      downloadType: "Please download the xlsx template",
      url: excelTemplate,
    },
  ];

  const input_alignments = [
    { label: "Left", value: 1 },
    { label: "Right", value: 3 },
    { label: "Center", value: 2 },
  ];

  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <SectionTitle>
          <SectionIcon>{"⚡"}</SectionIcon>
          Generate Notice
        </SectionTitle>

        <Grid item xs={12} style={{ marginBottom: "16px" }}>
          <RadioGroup
            style={{ flexDirection: "row", gap: "8px", marginLeft: "4px" }}
            name="typeOfSelect"
            value={values.typeOfSelect}
            onChange={(e) => setFieldValue("typeOfSelect", e.target.value)}
          >
            {radioTypeInputs.map((radio, key) => (
              <RadioChip
                key={key}
                selected={values.typeOfSelect === radio.value}
              >
                <FormControlLabel
                  classes={{ label: classes.formLabel }}
                  value={radio.value}
                  control={
                    <Radio
                      size="small"
                      style={{ color: COLORS.BTN_GREEN, padding: "6px" }}
                    />
                  }
                  label={radio.label}
                  style={{ margin: 0 }}
                />
              </RadioChip>
            ))}
          </RadioGroup>
        </Grid>

        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            trigger={true}
            value={values["partyId"]}
            {...{
              errors,
              touched,
              setFieldValue,
              menuItems,
              getNoticeTemplates,
              onPartySelect,
            }}
          />
          {inputs.map((input) => (
            <div key={input.name}>
              <FormField
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            </div>
          ))}

          {values.typeOfSelect === "excel" ? (
            upload_templates.map((upload, index) => (
              <UploadBlock key={index}>
                <FormLabel>
                  {upload.label}
                  <span className="required-star"> *</span>
                </FormLabel>
                <CustomFileUpload
                  error={touched[upload.name] && errors[upload.name]}
                  setFile={(file) =>
                    s3Upload(file, upload.name, setFieldValue, upload.types)
                  }
                  style={{ width: "100%" }}
                  accept={upload.accept}
                  file={{ name: getFileName(values[upload.name]) }}
                />
                {upload.url?.length && (
                  <Subheading>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={upload.url}
                    >
                      {upload.downloadType}
                    </a>
                  </Subheading>
                )}
              </UploadBlock>
            ))
          ) : values.typeOfSelect === "caseIds" ? (
            case_id_inputs.map((input, index) => (
              <FormField
                key={index}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            ))
          ) : values.typeOfSelect === "lotNumber" ? (
            lot_number_inputs.map((input, index) => (
              <FormField
                key={index}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            ))
          ) : (
            <UploadBlock>
              <FormLabel>
                Contract Numbers (Column name must be "Contract No"){" "}
                <span className="required-star"> *</span>
              </FormLabel>
              <CustomFileUpload
                error={touched["contractNumbers"] && errors["contractNumbers"]}
                setFile={(file) =>
                  s3UploadContractNumbers(
                    file,
                    `contractNumbers`,
                    setFieldValue,
                    `fileName`,
                  )
                }
                style={{
                  marginTop: 5,
                  width: "100%",
                }}
                accept=".xlsx"
                file={{ name: values.fileName }}
              />
            </UploadBlock>
          )}
        </ContainerGrid>

        <Divider />

        {/* Letter Head Type Radio */}
        <RadioSectionLabel>Letter Head Type</RadioSectionLabel>
        <Grid item xs={12} style={{ marginBottom: "16px" }}>
          <RadioGroup
            style={{ flexDirection: "row", gap: "8px", marginLeft: "4px" }}
            name="typeOfLetterHead"
            value={values.typeOfLetterHead}
            onChange={(e) => setFieldValue("typeOfLetterHead", e.target.value)}
          >
            {radioInputs.map((radio, key) => (
              <RadioChip
                key={key}
                selected={values.typeOfLetterHead === radio.value}
              >
                <FormControlLabel
                  classes={{ label: classes.formLabel }}
                  value={radio.value}
                  control={
                    <Radio
                      size="small"
                      style={{ color: COLORS.BTN_GREEN, padding: "6px" }}
                    />
                  }
                  label={radio.label}
                  style={{ margin: 0 }}
                />
              </RadioChip>
            ))}
          </RadioGroup>
        </Grid>

        <ContainerGrid>
          {[
            {
              type: "select",
              name: "letterHeadName",
              label: "Letter Head Name",
              required: false,
              items: menuHeaderFooter,
            },
          ].map((input, index) => (
            <div key={index}>
              <FormField
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
              {selectedLetterHead && selectedNoticeTemplate && (
                <Subheading style={{ marginTop: 8 }}>
                  <a
                    href="#preview"
                    onClick={(event) => {
                      event.preventDefault();
                      setModal({
                        state: true,
                        preview: true,
                        url: selectedNoticeTemplate,
                        name: "Notice Template",
                        format: "docx",
                        headerImage: selectedLetterHead.headerImage,
                        footerImage: selectedLetterHead.footerImage,
                      });
                    }}
                  >
                    Preview
                  </a>
                </Subheading>
              )}
            </div>
          ))}
          {values?.typeOfLetterHead === "text"
            ? [
                {
                  type: "select",
                  name: "headerAlignment",
                  label: "Header Alignment",
                  required: false,
                  items: input_alignments,
                },
                {
                  type: "select",
                  name: "footerAlignment",
                  label: "Footer Alignment",
                  required: false,
                  items: input_alignments,
                },
              ].map((input, index) => (
                <FormField
                  key={index}
                  menuItems={input.items}
                  {...{
                    touched,
                    errors,
                    input,
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                  }}
                />
              ))
            : null}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default GenerateNotice;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const SectionIcon = styled.span`
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.12),
    rgba(105, 227, 194, 0.15)
  );
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, rgba(0, 131, 140, 0.12), transparent);
  margin: 20px 0;
`;

const RadioSectionLabel = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  font-weight: 700;
  color: ${COLORS.INPUT_LABEL};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  margin-left: 4px;
`;

const RadioChip = styled.div`
  padding: 6px 14px;
  border-radius: 12px;
  // border: 1.5px solid
  //   ${({ selected }) => (selected ? COLORS.BTN_GREEN : "#e1e3ee")};
  background: ${({ selected }) =>
    selected ? "rgba(0, 131, 140, 0.07)" : "#f9fbfc"};
  transition: all 0.2s ease;
  cursor: pointer;
`;

const UploadBlock = styled.div`
  margin-top: 10px;
`;
